import React, { Component } from "react";
import "./App.css";
import MyNavbar from "./MyNavbar";
import AllPacks from "./AllPack";
import ReactDom from "react-dom";
import AboutUs from "./AboutUs";
import Icon from './icon';

class App extends Component {
  handleClick = menu => {
    const x = ReactDom.findDOMNode(this.refs[menu]);
    x.scrollIntoView({ block: "start", behavior: "smooth" });
  };

  render() {
    return (
      <div ref="home" className="App">
      <div onClick={() => this.handleClick('home')} className="scroll-top">
          <Icon icon="fa-chevron-circle-up" />
          Top
        </div>

        <MyNavbar refss={this.handleClick} />

        <div className="bg-img1">
          <div className="desc-holder">
            <div className="saichha">साईच्छा</div>
            <div className="cable">Cable Network</div>
          </div>
        </div>

        <div ref="channels">
          <AllPacks />
        </div>

        <div ref="about">
          <AboutUs />
        </div>
        <a href="http://103.199.99.130:8080/SubscriberLogin" className="pay-now">Recharge Now</a>
      </div>
    );
  }
}

export default App;
